import { createStorageValue } from '@interhyp/platform-storage';
import { createValue } from '@interhyp/platform-value';
import { z } from 'zod';
import { mortgageIntentNamespace } from '../namespaces';
const locationSchema = z.object({
    zip: z.string().min(5).max(5).optional(),
    city: z.string().optional(),
    name: z.string(),
});
/* location of the applicant (current residence)
 */
export const applicantLocationStorageValue = createStorageValue({
    namespace: mortgageIntentNamespace,
    id: Symbol('applicantLocation'),
    schema: locationSchema,
    type: 'local',
});
export const applicantLocationMemoryValue = createValue({
    namespace: mortgageIntentNamespace,
    id: Symbol('applicantLocationMemory'),
    schema: locationSchema,
});
/* net household income of the applicant
 */
export const netSalaryStorageValue = createStorageValue({
    namespace: mortgageIntentNamespace,
    id: Symbol('netSalary'),
    schema: z.number(),
    type: 'local',
});
export const netSalaryMemoryValue = createValue({
    namespace: mortgageIntentNamespace,
    id: Symbol('netSalaryMemory'),
    schema: z.number(),
});
